module.exports = __webpack_public_path__ + "img/黄连.769df145.jpg";